import { useEffect, useState } from "react";

/**
 * 客服 SDK 按需挂载开关。
 *
 * <p>背景：LiveChat / Tawk.to 的 SDK 都是远端重资源。实测首页加载 LiveChat 会产生
 * 24 个请求、跨 5 个域名、约 1MB（其中两次 364KB 的问候动图），起始时间正好落在
 * 骨架屏等游戏数据的窗口里，和游戏区图片抢带宽；而 widget 本身是 hideWidget 隐藏的，
 * 用户没点客服前完全用不到。
 *
 * <p>改法：首屏不挂载客服组件，等 openLiveChat() / openTawkChat() / openChatwoot() 真正被调用时置位，
 * App 才渲染对应组件、SDK 才开始加载。置位后不回退。
 */
let requested = false;
const listeners = new Set<() => void>();

export const isChatMountRequested = (): boolean => requested;

/** 由 openLiveChat / openTawkChat / openChatwoot 调用：请求挂载客服组件。 */
export const requestChatMount = (): void => {
  if (requested) return;
  requested = true;
  listeners.forEach(fn => {
    try {
      fn();
    } catch {
      /* 单个订阅者异常不影响其他订阅者 */
    }
  });
};

/** App 用：客服组件是否应该挂载。 */
export const useChatMountRequested = (): boolean => {
  const [mounted, setMounted] = useState(requested);

  useEffect(() => {
    if (mounted) return;
    const fn = () => setMounted(true);
    listeners.add(fn);
    // 订阅建立前可能已被置位，补一次检查避免丢事件
    if (requested) setMounted(true);
    return () => {
      listeners.delete(fn);
    };
  }, [mounted]);

  return mounted;
};
